export * from "./ILocalhostRegistry";
export * from "./IApplicationService";
export * from "./IPrinterService";
export * from "./IImageClipboardService";
export * from "./IWebApplicationMessageCommunicatable";
export * from "./WebApplicationInformation";
